module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Born to an American musician father, and English mother, "), _c('strong', [_vm._v("Jemma Wayne")]), _vm._v(" grew up in Hertfordshire and studied Social and Political Sciences at Cambridge University and Broadcast Journalism at the University of Westminster. She began her career as a journalist at The Jewish Chronicle, and later as a columnist for The Jewish News. She is now a regularly featured blogger at The Huffington Post and continues to contribute to a variety of other publications. Her first play, "), _c('em', [_vm._v("Negative Space")]), _vm._v(", was staged in 2009 at Hampstead’s New End Theatre, receiving critical acclaim.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("Jemma’s debut novel "), _c('em', [_vm._v("After Before")]), _vm._v(" was longlisted for the Baileys Women’s Prize for Fiction, longlisted for the Guardian Not the Booker Prize and shortlisted for the Waverton Good Read Award.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Visit Jemma at")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "http://jemmawayne.com",
      "target": "_blank"
    }
  }, [_vm._v("jemmawayne.com")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("or on Twitter")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/writejemmawayne",
      "target": "_blank"
    }
  }, [_vm._v("@writejemmawayne")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81f1ea0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fm01.vue
// module id = 63
// module chunks = 0